import { graphdata } from "./typing"

export interface graphState {
    view:{
        loaded: boolean, 
        autorefresh: boolean,
    },
    config : {
      data: graphdata[],
      xField: string,
      yField: string,
      label: {
        position: string,
        style: {
          fill: string,
          opacity: number,
        },
      },
      yAxis:{
        title: {
          text: string,
          style: {
              fill: string,
              fontSize: number
          },
        },
      },
      xAxis: {
        label: {
          autoHide: boolean,
          autoRotate: boolean,
          style: {
            fill: string,
          },
        },
        title: {
          text: string,
          style: {
              fill: string,
              fontSize: number
          },
      }
      },
      meta: {
        severity: { alias: string, values : string[] },
        count: { alias: string },
      },
      
  }
}

export const graphInitialState : graphState = {
    view:{
        loaded: false,
        autorefresh: false,
    },
    config : {
      data : [
        {severity:1, count:0},
        {severity:2, count:0},
        {severity:3, count:0},
        {severity:4, count:0},
        {severity:5, count:0},
        {severity:6, count:0},
        {severity:7, count:0},
        {severity:8, count:0},
        {severity:9, count:0},
      ],
      xField: 'severity',
      yField: 'count',
      label: {
        position: 'middle',
        style: {
          fill: '#CCBBCC',
          opacity: 0.6,
        },
      },
      yAxis:{
        title: {
          text: "",
          style: {
              fill: "#6E759F",
              fontSize: 14
          },
        },
      },
      xAxis: {
        label: {
          autoHide: false,
          autoRotate: false,
          style: {
            fill: '#CCBBCC',
          },
        },
        title: {
          text: "Severity",
          style: {
              fill: "#6E759F",
              fontSize: 14
          },
      }
      },
      meta: {
        severity: { alias: 'severity', values:["0","1","2","3","4","5","6","7","8","9","10"] },
        count: { alias: 'count' },
      },
     
    }
    }


export function deepCopyGraphThingyState(toCopy:graphState):graphState{
    return {
        view:{
            loaded:toCopy.view.loaded,
            autorefresh:toCopy.view.autorefresh
        },
        config : {
          data : [
            {severity:1, count:0},
            {severity:2, count:0},
            {severity:3, count:0},
            {severity:4, count:0},
            {severity:5, count:0},
            {severity:6, count:0},
            {severity:7, count:0},
            {severity:8, count:0},
            {severity:9, count:0},
          ],
          xField: 'severity',
          yField: 'count',
          label: {
            position: 'middle',
            style: {
              fill: '#CCBBCC',
              opacity: 0.6,
            },
          },
          yAxis:{
            title: {
              text: "",
              style: {
                  fill: "#6E759F",
                  fontSize: 14
              },
            },
          },
          xAxis: {
            label: {
              autoHide: false,
              autoRotate: false,
              style: {
                fill: '#CCBBCC',
              },
            },
            title: {
              text: "Severity",
              style: {
                  fill: "#6E759F",
                  fontSize: 14
              },
          }
          },
          meta: {
            severity: { alias: 'severity', values:["0","1","2","3","4","5","6","7","8","9","10"] },
            count: { alias: 'count' },
          },
         
        }
    }
    
}